import { FC, useEffect, useState } from 'react';
import styles from './styles.module.css';
import { useGetCarCategoriesQuery } from '../../../../../api/carApi';
import CheckBoxGroup, {
  CheckBoxGroupOnChangeProps,
  ValueObj,
} from '../../../../../components/common/CheckBoxGroup';
import SectionHead from '../../SectionHead';
import { ContractFormData } from '../../../../../types/contracts';
import { useFormContext } from 'react-hook-form';
import Label from '../../../../../components/common/Label';
import { ErrorMessage } from '@hookform/error-message';
import Caption, {
  CaptionsUnderForm,
} from '../../../../../components/common/Caption';
import { required } from '../../../../../message';

const CarCategoriesForm: FC = () => {
  const { register, getValues, setValue, getFieldState } =
    useFormContext<ContractFormData>();
  const { data: carCategories } = useGetCarCategoriesQuery();
  const [carCategoryValues, setCarCategoryValues] = useState<ValueObj[]>([]);
  useEffect(() => {
    const selected = getValues('carCategoryIds');
    setCarCategoryValues(
      (carCategories || []).map((category) => ({
        label: category.carCategory,
        value: `${category.carCategoryId}`,
        checked: selected.includes(category.carCategoryId),
      }))
    );
  }, [carCategories]);
  const onChange = ({ values, selectedValues }: CheckBoxGroupOnChangeProps) => {
    setCarCategoryValues(values);
    setValue(
      'carCategoryIds',
      selectedValues.map((v) => Number(v)),
      { shouldValidate: true }
    );
  };

  register('carCategoryIds', {
    required: required('使用車両'),
  });

  return (
    <>
      <SectionHead>車両割り当て</SectionHead>
      <Label>使用車両</Label>
      <div className={styles.carCategoryIds}>
        <CheckBoxGroup
          values={carCategoryValues}
          variants={getFieldState('carCategoryIds').error ? ['error'] : []}
          onChange={onChange}
          styleType="carCategory"
        />
        <CaptionsUnderForm>
          <ErrorMessage
            name="carCategoryIds"
            render={(message) => (
              <Caption variants={['error']}>{message.message}</Caption>
            )}
          />
        </CaptionsUnderForm>
      </div>
    </>
  );
};

export default CarCategoriesForm;
